import { active_user, active_roles } from "../../configs/app.js";

export default {
    actions: {
        async authenticatedUser({ commit }, payload) {
            return commit("SET_USER", payload);
        },
        async logout({ commit }) {
            await window.axios.post("/logout").then(() => commit("SET_NULL"));
        },
    },
    getters: {
        authenticated(state) {
            return Boolean(state.user);
        },

        user(state) {
            return state.user;
        },
    },
    mutations: {
        SET_USER(state, payload) {
            state.user = payload.autheried;
        },
        SET_NULL(state) {
            state.user = null;
            window.location.reload();
        },
    },
    namespaced: true,
    state: {
        user: active_user,
    },
};
